module.exports = __webpack_public_path__ + "img/big1-4.7892bec0.jpg";